import * as React from "react";
import { Panel } from "react-bootstrap";

import { EmploymentMilitaryIncomeShape } from "@eave/shared/types/api";

import SumSectionHeading from "web_modules/shared/SectionHeading/SumSectionHeading";

const styles = require("./styles.module.scss");

const dollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const decimalToDollars = (d: string): string => {
  const num = Number(d);
  return num === 0 ? "0" : dollarFormatter.format(num);
};

interface Props {
  militaryIncome: EmploymentMilitaryIncomeShape;
}

const MilitaryIncomeSection = ({ militaryIncome }: Props) => {
  const {
    base_pay,
    clothes_allowance,
    combat_pay,
    flight_pay,
    hazard_pay,
    overseas_pay,
    prop_pay,
    quarters_allowance,
    rations_allowance,
    variable_housing_allowance,
    entitlements_total,
    monthly_total,
  } = militaryIncome;

  return (
    <div className={styles.container}>
      <SumSectionHeading
        sectionLabel="Monthly US military income"
        value={Number(monthly_total)}
        description="Total pay & entitlements"
        addends={[
          {
            description: "Base pay",
            value: Number(base_pay),
          },
          {
            description: "All other pay & entitlements",
            value: Number(entitlements_total),
          },
        ]}
      />
      <div className={styles.content}>
        <Panel className="employments" defaultExpanded>
          <Panel.Body>
            <dl className="dl-horizontal salaried_income__summary">
              <dt>Base pay</dt>
              <dd>{decimalToDollars(base_pay)}</dd>
            </dl>
            <div className={styles.symbol}>
              <dl className="dl-horizontal salaried_income__summary">
                <dt></dt>
                <dd>+</dd>
              </dl>
            </div>
            <dl className="dl-horizontal salaried_income__summary">
              <dt>Clothes allowance</dt>
              <dd>{decimalToDollars(clothes_allowance)}</dd>
              <dt>Combat pay</dt>
              <dd>{decimalToDollars(combat_pay)}</dd>
              <dt>Flight pay</dt>
              <dd>{decimalToDollars(flight_pay)}</dd>
              <dt>Hazard pay</dt>
              <dd>{decimalToDollars(hazard_pay)}</dd>
              <dt>Overseas pay</dt>
              <dd>{decimalToDollars(overseas_pay)}</dd>
              <dt>Prop pay</dt>
              <dd>{decimalToDollars(prop_pay)}</dd>
              <dt>Quarters allowance</dt>
              <dd>{decimalToDollars(quarters_allowance)}</dd>
              <dt>Rations allowance</dt>
              <dd>{decimalToDollars(rations_allowance)}</dd>
              <dt>Variable housing allowance</dt>
              <dd>{decimalToDollars(variable_housing_allowance)}</dd>
              <dt>All other pay & entitlements</dt>
              <dd className={styles.total}>{decimalToDollars(entitlements_total)}</dd>
            </dl>
            <div className={styles.symbol}>
              <dl className="dl-horizontal salaried_income__summary">
                <dt></dt>
                <dd>=</dd>
              </dl>
            </div>
            <dl className="dl-horizontal salaried_income__summary">
              <dt>Total pay & entitlements</dt>
              <dd>{decimalToDollars(monthly_total)}</dd>
            </dl>
          </Panel.Body>
        </Panel>
      </div>
    </div>
  );
};

export default MilitaryIncomeSection;
